import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTools = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 41,
	viewBox: "0 0 41 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.7501 15.7504C22.5974 15.9062 22.5119 16.1156 22.5119 16.3338C22.5119 16.5519 22.5974 16.7613 22.7501 16.9171L24.0835 18.2504C24.2392 18.4031 24.4487 18.4886 24.6668 18.4886C24.8849 18.4886 25.0943 18.4031 25.2501 18.2504L28.3918 15.1088C28.8108 16.0348 28.9377 17.0665 28.7555 18.0664C28.5733 19.0663 28.0907 19.987 27.372 20.7057C26.6533 21.4244 25.7327 21.907 24.7327 22.0891C23.7328 22.2713 22.7011 22.1445 21.7751 21.7254L16.0168 27.4838C15.6853 27.8153 15.2356 28.0015 14.7668 28.0015C14.2979 28.0015 13.8483 27.8153 13.5168 27.4838C13.1853 27.1522 12.999 26.7026 12.999 26.2338C12.999 25.7649 13.1853 25.3153 13.5168 24.9838L19.2751 19.2254C18.8561 18.2994 18.7292 17.2677 18.9114 16.2678C19.0936 15.2679 19.5762 14.3472 20.2949 13.6285C21.0136 12.9098 21.9342 12.4272 22.9342 12.245C23.9341 12.0629 24.9658 12.1897 25.8918 12.6088L22.7585 15.7421L22.7501 15.7504Z",
		stroke: "#50566E",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTools;
